var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'planes-de-pago')?_c('div',[_c('nav-component'),_c('cuotas-pendientes'),_c('cuotas-pagas')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }